// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ciwm","top":"styles_top__Repf7"};